export default __webpack_public_path__ + "static/media/new-gams-logo.5d5edecd.png";